import { useState } from 'react';
import { Price, Select } from '@artosera/ui';
import { useTranslation } from 'react-i18next';
import { usePrevision } from '../../api/pipeline.js';
import { useShellContext } from '../shell/context.js';
import styles from './Pipeline.module.css';
export function Prevision() {
  const { galerieSlug } = useShellContext();
  const { t, i18n } = useTranslation('regie');
  const [trimestre, setTrimestre] = useState<'en_cours' | 'suivant'>('en_cours');
  const prevision = usePrevision(galerieSlug, trimestre);
  const chiffres = prevision.data;
  if (
    prevision.isError ||
    !chiffres ||
    typeof chiffres.realiseCentimes !== 'number' ||
    typeof chiffres.pondereCentimes !== 'number' ||
    typeof chiffres.sansDateCentimes !== 'number'
  )
    return null;
  const langue = i18n.language === 'en' ? 'en' : 'fr';
  return (
    <section className={styles.prevision} aria-label={t('pipeline.prevision')}>
      <h2>{t('pipeline.prevision')}</h2>
      <Select
        aria-label={t('pipeline.trimestre')}
        value={trimestre}
        onValueChange={(v) => setTrimestre(v as typeof trimestre)}
        options={['en_cours', 'suivant'].map((value) => ({
          value,
          label: t(`pipeline.trimestres.${value}`),
        }))}
      />
      <p>
        {t('pipeline.periode', {
          numero: chiffres.trimestre.numero,
          annee: chiffres.trimestre.annee,
        })}
      </p>
      <dl className={styles.chiffres}>
        {(['realiseCentimes', 'pondereCentimes', 'sansDateCentimes'] as const).map((cle) => (
          <div key={cle} className={cle === 'sansDateCentimes' ? styles.sansDate : undefined}>
            <dt>{t(`pipeline.${cle}`)}</dt>
            <dd>
              <Price cents={chiffres[cle]} currency={chiffres.devise} lang={langue} />
            </dd>
          </div>
        ))}
      </dl>
      {chiffres.comparaison ? (
        <div>
          <h3>{t('pipeline.comparaison')}</h3>
          <dl className={styles.chiffres}>
            {(['realiseCentimes', 'pondereCentimes', 'sansDateCentimes'] as const).map((cle) => (
              <div key={cle}>
                <dt>{t(`pipeline.${cle}`)}</dt>
                <dd>
                  <Price
                    cents={chiffres.comparaison![cle]}
                    currency={chiffres.devise}
                    lang={langue}
                  />
                </dd>
              </div>
            ))}
          </dl>
        </div>
      ) : null}
    </section>
  );
}
